const buttons = document.querySelectorAll('.logo-button');
const grids = document.querySelectorAll('.products-grid');

// Add event listeners to each sidebar button
buttons.forEach((button) => {
    button.addEventListener('click', () => {
        const category = button.getAttribute("data-category");
        showCategory(category);
    });
});

function showCategory(category) {
    //show the grid
    grids.forEach((grid) => {
        if (grid.id === category) {
        grid.classList.add('active');
        } else {
        grid.classList.remove('active');
        }
    });

    // Highlight the active button  
    buttons.forEach((button) => {
        if (button.getAttribute('data-category') === category) {
        button.classList.add('brand-selected');
        } else {
        button.classList.remove('brand-selected');
        }
    });
    }
